module.exports = __webpack_public_path__ + "static/ourworkflow_dots-199c8f7c05631dbbebdd492697e5a7ce.svg";